import { apiAiFrameworkRuns } from '@modules/ai-framework/api/apiAiFrameworkRuns'
import { EXECUTIONS } from '@modules/ai-framework/constants/copy'

// Slice `runs` (spec-004 G14) — sub-módulo namespaced `aiFramework/runs/*`. READ-ONLY:
// nenhuma action muta run/step. Toda action lê `r.status` do BODY (HTTP-200-always).
const STATUS_OK = 200
const STATUS_FORBIDDEN = 403
const STATUS_NOT_FOUND = 404
const DEFAULT_LIMIT = 20

const state = () => ({
  list: [], // RunListItem[]
  total: 0,
  // Detalhe do run aberto no drawer: run + steps + decisões, ou null.
  detail: null,
  loadingList: false,
  loadingDetail: false,
  forbidden: false,
  filters: { idInstance: null, idProfissional: null, canal: null, status: null, de: null, ate: null },
  page: { limit: DEFAULT_LIMIT, offset: 0 },
})

const getters = {
  runsList: (s) => s.list || [],
  runsTotal: (s) => s.total || 0,
  runDetail: (s) => s.detail,
  loadingRuns: (s) => s.loadingList,
  loadingRunDetail: (s) => s.loadingDetail,
  runsForbidden: (s) => s.forbidden,
  runsFilters: (s) => s.filters || {},
  runsPage: (s) => s.page || {},
}

const mutations = {
  SET_LIST(s, payload) {
    s.list = payload || []
  },
  SET_TOTAL(s, payload) {
    s.total = payload || 0
  },
  SET_DETAIL(s, payload) {
    s.detail = payload || null
  },
  SET_LOADING_LIST(s, payload) {
    s.loadingList = payload
  },
  SET_LOADING_DETAIL(s, payload) {
    s.loadingDetail = payload
  },
  SET_FORBIDDEN(s, payload) {
    s.forbidden = payload
  },
  SET_FILTERS(s, payload) {
    s.filters = { ...s.filters, ...payload }
  },
  SET_PAGE(s, payload) {
    s.page = { ...s.page, ...payload }
  },
}

// Monta os params da API a partir do estado (filtros + paginação).
function buildRunsParams(state) {
  return {
    idInstance: state.filters.idInstance,
    idProfissional: state.filters.idProfissional,
    canal: state.filters.canal,
    status: state.filters.status,
    de: state.filters.de,
    ate: state.filters.ate,
    limit: state.page.limit,
    offset: state.page.offset,
  }
}

// Aplica o resultado da lista de runs (extraído para manter a action enxuta).
function applyRunsResult({ commit, dispatch }, r) {
  if (r && r.status === STATUS_OK) {
    const value = r.value || {}
    commit('SET_LIST', value.runs || [])
    commit('SET_TOTAL', value.total || 0)
    commit('SET_FORBIDDEN', false)
    return
  }
  if (r && r.status === STATUS_FORBIDDEN) {
    commit('SET_LIST', [])
    commit('SET_TOTAL', 0)
    commit('SET_FORBIDDEN', true)
    return
  }
  commit('SET_LIST', [])
  commit('SET_TOTAL', 0)
  dispatch('feedback/showSnack', r, { root: true })
}

const actions = {
  async fetchRuns({ commit, dispatch, state }, { filters, page } = {}) {
    if (filters) commit('SET_FILTERS', filters)
    if (page) commit('SET_PAGE', page)
    commit('SET_LOADING_LIST', true)
    const r = await apiAiFrameworkRuns.list(buildRunsParams(state))
    applyRunsResult({ commit, dispatch }, r)
    commit('SET_LOADING_LIST', false)
    return r
  },

  async fetchRunDetail({ commit, dispatch }, idRun) {
    commit('SET_LOADING_DETAIL', true)
    commit('SET_DETAIL', null)

    const r = await apiAiFrameworkRuns.detail(idRun)

    if (r && r.status === STATUS_OK) {
      commit('SET_DETAIL', r.value || null)
    } else if (r && r.status === STATUS_NOT_FOUND) {
      // 404 opaco (cross-tenant/inexistente/fora do escopo): snack + fecha o drawer.
      dispatch('feedback/showSnack', { text: EXECUTIONS.NOT_FOUND, color: 'error', button: true }, { root: true })
    } else {
      dispatch('feedback/showSnack', r, { root: true })
    }

    commit('SET_LOADING_DETAIL', false)
    return r
  },

  clearDetail({ commit }) {
    commit('SET_DETAIL', null)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
